import { CustomCellEditorProps } from "ag-grid-react";
import { useCallback, useMemo } from "react";

import { BTSelectItem } from "types/apiResponse/apiResponse";

import { BTSelect } from "commonComponents/btWrappers/BTSelect/BTSelect";
import type { CustomFieldDefinition } from "commonComponents/entity/customField/utils/customFieldDefinition.util";

import { DropdownCustomFieldDefinition } from "handlers";

interface IDropdownCellEditorParams {
    definition?: CustomFieldDefinition;
}

export const DropdownCellEditor = (
    props: CustomCellEditorProps<unknown, number> & IDropdownCellEditorParams,
) => {
    const { value, onValueChange, stopEditing, definition } = props;

    const treeData = useMemo(() => {
        if (!definition) return [];
        const dropdownDef = definition as DropdownCustomFieldDefinition;
        return (dropdownDef.options ?? []).map(
            (opt) => new BTSelectItem({ id: opt.id, name: opt.text, value: opt.id }),
        );
    }, [definition]);

    const selectedValues = value != null && value !== -1 ? [value] : [];

    const getPopupContainer = useCallback((triggerNode: HTMLElement): HTMLElement => {
        return triggerNode.parentNode instanceof HTMLElement
            ? triggerNode.parentNode
            : document.body;
    }, []);

    const columnWidth = props.column?.getActualWidth();
    const widthStyle = columnWidth
        ? { width: `${Math.max(0, columnWidth - 8)}px`, marginLeft: 4, marginTop: 4 }
        : undefined;

    return (
        <div className="custom-field-select-editor" style={widthStyle}>
            <BTSelect
                id="dropdownCellEditor"
                data-testid="dropdownCellEditor"
                value={selectedValues}
                treeData={treeData}
                defaultOpen
                dropdownCanExpand={false}
                getPopupContainer={getPopupContainer}
                onChange={(_id, val) => {
                    onValueChange(val != null ? (val as number) : null);
                    stopEditing();
                }}
                onBlur={() => stopEditing()}
                multiple={false}
            />
        </div>
    );
};
